module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS.af1d9a9.woff2";